import * as React from "react";
import { forwardRef } from "react";
const SvgForwardArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 25, viewBox: "0 0 13 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M1 1L11.7355 11.8808C11.819 11.9602 11.8855 12.0561 11.931 12.1626C11.9765 12.2691 12 12.3839 12 12.5C12 12.6161 11.9765 12.7309 11.931 12.8374C11.8855 12.9439 11.819 13.0398 11.7355 13.1192L1 24", stroke: "#FFA057", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgForwardArrow);
export { ForwardRef as ReactComponent };
